import React, { useState } from "react";
import {
  AiFillApple,
  AiFillFacebook,
  AiFillGoogleCircle,
  AiOutlineArrowLeft,
} from "react-icons/ai";
import { NavLink, useNavigate } from "react-router-dom";

import { apiURL } from "../api/index";

function Login() {
  const Navigate = useNavigate();
  const [message, setMessage] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = async (e) => {
    e.preventDefault();

    const res = await fetch(`${apiURL}/login`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json();

    if (res.status === 400) {
      setMessage(data);
      setTimeout(() => {
        setMessage("");
      }, 2000);
    } else if (res.status === 420) {
      setMessage(data);
      setTimeout(() => {
        setMessage("");
      }, 2000);
    } else if (res.status === 200) {
      Navigate("/");
      setMessage(data);
    } else if (res.status === 450) {
      setMessage(data);
      setTimeout(() => {
        setMessage("");
      }, 2000);
    }
  };

  return (
    <>
      {message && (
        <div className="bg-red-600 text-white p-2 w-full text-center font-semibold absolute">
          {message.message}
        </div>
      )}
      <NavLink to="/">
        <div className="flex justify-center items-center absolute top-10 left-5">
          <AiOutlineArrowLeft size="20" />
          <img
            className="bg-choice"
            width="55px"
            src="/images/digitalmechanic.png"
            alt="logo"
          />
          <span className="text-xl md:text-2xl">DigitalMechanic</span>
        </div>
      </NavLink>
      <NavLink to="/">
        <div className="flex justify-center items-center absolute top-10 left-5">
          <AiOutlineArrowLeft size="20" />
          <img
            className="bg-choice"
            width="55px"
            src="/images/digitalmechanic.png"
            alt="logo"
          />
          <span className="text-xl md:text-2xl">DigitalMechanic</span>
        </div>
      </NavLink>
      <div className="font-primary flex justify-center items-center w-[88%] mx-auto h-[100vh]">
        <div className="flex text-center bg-primary text-white rounded-2xl p-10 flex-col h-[60vh] my-10 justify-between">
          <h2 className="text-2xl font-semibold">Account Login</h2>
          <p className="my-2 text-sm w-72 mx-auto text-center">
            Hey, Enter your details to get sign in to your account
          </p>
          <input
            className="login-input"
            type="text"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Email..."
          />
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
            type="password"
            name="password"
            placeholder="Passcode..."
          />
          <button
            onClick={(e) => login(e)}
            className="my-2 border border-black-200 bg-secondary rounded-lg p-2 outline-none"
          >
            Sign in
          </button>
          <span className="text-sm my-4">- Or Sign in with -</span>
          <div className="flex justify-around">
            <div className="login-icons">
              <button>
                <AiFillGoogleCircle />
              </button>
              <span>Google</span>
            </div>
            <div className="login-icons">
              <button>
                <AiFillFacebook />
              </button>
              <span>Facebook</span>
            </div>
            <div className="login-icons">
              <button>
                <AiFillApple />
              </button>
              <span>Apple ID</span>
            </div>
          </div>
          <span className="text-sm my-2">
            Don't have an account?{" "}
            <button className="text-secondary font-semibold">
              <NavLink to="/register">Register Now</NavLink>
            </button>
          </span>
        </div>
      </div>
    </>
  );
}

export default Login;
